__turbopack_context__.v({
  "burder": "Header-module-scss-module__MMVm5q__burder",
  "burger": "Header-module-scss-module__MMVm5q__burger",
  "header": "Header-module-scss-module__MMVm5q__header",
  "logoLink": "Header-module-scss-module__MMVm5q__logoLink",
  "logoMobile": "Header-module-scss-module__MMVm5q__logoMobile",
  "mobileMenu": "Header-module-scss-module__MMVm5q__mobileMenu",
  "stack-module-0": "Header-module-scss-module__MMVm5q__stack-module-0",
  "stack-module-1": "Header-module-scss-module__MMVm5q__stack-module-1",
  "stack-module-10": "Header-module-scss-module__MMVm5q__stack-module-10",
  "stack-module-11": "Header-module-scss-module__MMVm5q__stack-module-11",
  "stack-module-12": "Header-module-scss-module__MMVm5q__stack-module-12",
  "stack-module-13": "Header-module-scss-module__MMVm5q__stack-module-13",
  "stack-module-14": "Header-module-scss-module__MMVm5q__stack-module-14",
  "stack-module-15": "Header-module-scss-module__MMVm5q__stack-module-15",
  "stack-module-16": "Header-module-scss-module__MMVm5q__stack-module-16",
  "stack-module-17": "Header-module-scss-module__MMVm5q__stack-module-17",
  "stack-module-18": "Header-module-scss-module__MMVm5q__stack-module-18",
  "stack-module-19": "Header-module-scss-module__MMVm5q__stack-module-19",
  "stack-module-2": "Header-module-scss-module__MMVm5q__stack-module-2",
  "stack-module-20": "Header-module-scss-module__MMVm5q__stack-module-20",
  "stack-module-3": "Header-module-scss-module__MMVm5q__stack-module-3",
  "stack-module-4": "Header-module-scss-module__MMVm5q__stack-module-4",
  "stack-module-5": "Header-module-scss-module__MMVm5q__stack-module-5",
  "stack-module-6": "Header-module-scss-module__MMVm5q__stack-module-6",
  "stack-module-7": "Header-module-scss-module__MMVm5q__stack-module-7",
  "stack-module-8": "Header-module-scss-module__MMVm5q__stack-module-8",
  "stack-module-9": "Header-module-scss-module__MMVm5q__stack-module-9",
  "z-base": "Header-module-scss-module__MMVm5q__z-base",
  "z-content": "Header-module-scss-module__MMVm5q__z-content",
  "z-footer": "Header-module-scss-module__MMVm5q__z-footer",
  "z-header": "Header-module-scss-module__MMVm5q__z-header",
  "z-hero": "Header-module-scss-module__MMVm5q__z-hero",
  "z-logo": "Header-module-scss-module__MMVm5q__z-logo",
  "z-logo-effect": "Header-module-scss-module__MMVm5q__z-logo-effect",
  "z-navigation": "Header-module-scss-module__MMVm5q__z-navigation",
  "z-sub": "Header-module-scss-module__MMVm5q__z-sub",
});
